import { render, staticRenderFns } from "./send-new-device-email-modal.vue?vue&type=template&id=a1bdb652"
import script from "./send-new-device-email-modal.vue?vue&type=script&lang=ts"
export * from "./send-new-device-email-modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports